import React, { useState } from "react";
import { Layout } from "../layouts/Layout";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Input,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/core";
import { useForm } from "react-hook-form";
import CustomBreadcrumb from "../layouts/Breadcrumb";
import { resetUserPassword } from "../api/user.service";
import successImg from "../assets/icons/icon-sent.png";

const ForgotPassword = () => {
  const { register, handleSubmit, errors, formState, reset } = useForm();
  const [toggleState, setToggleState] = useState(false);

  const toast = useToast();

  const onSubmitHandler = async (values) => {
    try {
      const res = await resetUserPassword(values);
      toast({
        title: "Forgot Password",
        description: "A reset link has been sent to the email provided.",
        position: "top-right",
        status: "success",
        isClosable: true,
      });
      reset();
      setToggleState(true);
    } catch (error) {
      toast({
        title: "Forgot Password",
        description:
          "Password reset failed. Please provide correct credentials.",
        position: "top-right",
        status: "success",
        isClosable: true,
      });
      console.log(error);
    }
  };

  return (
    <Layout>
      <Box px={["10", "25%"]} py={["10", "40"]} mt={["20", "80px"]}>
        <Stack mx="auto" bg="white" shadow="md" px="20" py="6" spacing="6">
          {!toggleState && (
            <Stack>
              <Text mb="4" textAlign="center" fontSize="2xl" fontWeight="600">
                Reset Password
              </Text>

              <Text fontSize="16px" color="green.400">
                A link will be sent to the email you enter to reset your
                password
              </Text>
            </Stack>
          )}

          {!toggleState ? (
            <form onSubmit={handleSubmit(onSubmitHandler)}>
              <Stack pb="10" spacing="6">
                <FormControl mb="6" mr={["0", "2"]} flex="1" isRequired>
                  <FormLabel
                    htmlFor="first_name"
                    isInvalid={errors.first_name}
                    fontFamily="Familiar Pro"
                  >
                    Email Address
                  </FormLabel>
                  <Input
                    type="email"
                    placeholder="Enter your email to reset password"
                    name="email"
                    ref={register({ required: "Field is required" })}
                  ></Input>
                  <FormErrorMessage>
                    {errors.email && errors.email.message}
                  </FormErrorMessage>
                </FormControl>
              </Stack>
              <Button
                type="submit"
                variantColor="green"
                rightIcon="arrow-forward"
                my="4"
                isLoading={formState.isSubmitting}
              >
                Submit
              </Button>
            </form>
          ) : (
            <Stack>
              <Text mb="4" textAlign="center" fontSize="2xl" fontWeight="600">
                Email Sent
              </Text>
              <Text fontSize="16px" color="green.400">
                A link has been sent to the email you enter to reset your
                password. Kindly check your email.
              </Text>
              <Flex justify="center" align="center" my="10">
                <Image src={successImg} width="100px" height="100px" />
              </Flex>
            </Stack>
          )}
        </Stack>
      </Box>
    </Layout>
  );
};

export default ForgotPassword;
